import { useContext } from 'react';

import { DisplayConfigContext } from '../contexts/DisplayConfigContext.js';

export const useDisplayConfigContext = () => useContext(DisplayConfigContext);

DisplayConfigContext['displayName'] = 'DisplayConfigContext';
